module.exports = __webpack_public_path__ + "static/ACCM-c4918c3cea64cce4de61fa9b4d5f08b1.png";